import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';

import {
    MAINTENANCE_DEV_ACCESS_KEY,
    MAINTENANCE_TRIGGERED_KEY,
} from 'constants/storageKeys';
import { All_PATHS_NAMESPACES } from 'routes/definedRoutes';
import { getStorageItem } from 'services/storage';

function PublicOutlet({ user = {}, lang = 'fr' }) {
    const navigate = useNavigate();

    useEffect(() => {
        const maintenanceTriggered = getStorageItem(MAINTENANCE_TRIGGERED_KEY) || false;
        const hasAccess = getStorageItem(MAINTENANCE_DEV_ACCESS_KEY) || false;

        if(maintenanceTriggered && !hasAccess) {
            navigate(All_PATHS_NAMESPACES[lang].maintenance.path);

            return;
        }

        if (!isEmpty(user)) {
            navigate(All_PATHS_NAMESPACES[lang].home.path);
        }
    }, [user, lang, navigate]);

    return <Outlet />;
}

const mapStateToProps = (state) => ({
    user: state.user,
    lang: state.locale,
});

export default connect(mapStateToProps, null)(PublicOutlet);
